import { Directive } from '@angular/core';
import { AbstractControl, UntypedFormGroup, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { TitleValidationService } from '../services/title-validation.service';

export const assessmentNameValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const name = control.get('title');
  if (!name || name.value === undefined || name.value === null) {
    return null;
  }

  return name.value.replace(/\s+/g, '').toLowerCase() === 'unnamedtest'
    ? { 'validated': 'Unnamed Test' }
    : null;
};

@Directive({
    selector: '[assessmentName]',
    providers: [{ provide: NG_VALIDATORS, useExisting: AssessmentNameValidatorDirective, multi: true }],
    standalone: false
})
  export class AssessmentNameValidatorDirective implements Validator {
    constructor(private titleValidationService: TitleValidationService) {}

    validate(control: AbstractControl): ValidationErrors {
      const nameControl = control.get('title');
      if (nameControl && this.titleValidationService.containsHtmlTag(nameControl.value)) {
        return { invalidTitleFormat: true };
      }

      return assessmentNameValidator(control as UntypedFormGroup);
    }
  }